import ExitLogo from '../assets/images/banner-logo-exit.svg';
import Banner from '../components/Banner';
import successIcon from '../assets/images/success.svg';

const ThankyouPage = () => {
  return (
    <div>
      <Banner bannerImage={ExitLogo} />
      <div className="thank-you-page-content">
        <img src={successIcon} alt="success-checked" className="success-logo" />
        <p className="request-processed-message">
          You have requested an unclaimed property check, please allow 7-10
          business days for delivery to the address you provided.
        </p>
        <p className="exit-page-message">
          Now, you can close out of this window.
        </p>
      </div>
    </div>
  );
};

export default ThankyouPage;
